module.exports = __webpack_public_path__ + "img/herobanner-image.0a99e4f2.jpg";